import React, { useCallback, useEffect, useRef, useState } from "react";
import SingleDigitScreen from "./DigitPages/SingleDigitScreen";
import DoubleDigitScreen from "./DigitPages/DoubleDigitScreen";
import ThreeDigitScreen from "./DigitPages/ThreeDigitScreen";
import { priceDoc } from "../assets/img";
import { Toast } from "../Component/Toast";
import { useLocation, useNavigate } from "react-router-dom";
import Countdown from "../Component/Countdown";
import { URLS } from "../Services/Constant";
import { get } from "../Services/ApiHandler";
import useStore from "./redux/store/useStore";
import moment from "moment";
import { useAppContext } from "../Services/AppContext";
import useStoreKv from "../LocalStore/useStore";
const LotteryGameScreen = () => {
  const set = useStoreKv((state) => state.set);

  const [loading, setLoading] = useState(false);
  const naviagtion = useNavigate();
  const location = useLocation();
  const [isLotClosed, setIsLotClosed] = useState(false);
  const [isBookingClosed, setIsBookingClosed] = useState(false);

  const slotTime = location.state?.slotTime;
  const bookingTime = location.state?.bookingTime;
  const lotName = location.state?.lotName;
  const time = location.state?.time;
  const slotId = location.state?.slotId;
  const { user, slot } = useStore();
  const { triggerTimer } = useAppContext();

  const userId = user?.id;

  const doubleData = [
    {
      lottery: "kerala",
      digit_name: "Double Digits Win",
      win_price: "1000",
      buy_price: 11.0,
      alpha: "A",
      alpha2: "B",
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Double Digits Win",
      win_price: "1000",
      buy_price: 11.0,
      alpha: "B",
      alpha2: "C",
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Double Digits Win",
      win_price: "1000",
      buy_price: 11.0,
      alpha: "A",
      alpha2: "C",
      time: time,
    },
  ];

  const [threeData, setThreeData] = useState([
    {
      lottery: "kerala",
      digit_name: "Three Digit",
      win_price: "6250",
      price_name: "Buy price",
      digit_fee: 12.0,
      alpha: ["A", "B", "C"],
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Three Digit",
      win_price: "10,000",
      price_name: "Buy price",
      digit_fee: 22.0,
      alpha: ["A", "B", "C"],
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Three Digit",
      win_price: "15,000",
      price_name: "Buy price",
      digit_fee: 28.0,
      alpha: ["A", "B", "C"],
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Three Digit",
      win_price: "17,500",
      price_name: "Buy price",
      digit_fee: 30.0,
      alpha: ["A", "B", "C"],
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Three Digit",
      win_price: "30,000",
      price_name: "Buy price",
      digit_fee: 55.0,
      alpha: ["A", "B", "C"],
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Three Digit",
      win_price: "35,000",
      price_name: "Buy price",
      digit_fee: 60.0,
      alpha: ["A", "B", "C"],
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Four Digit",
      win_price: "1,00,000",
      price_name: "Buy price",
      digit_fee: 20.0,
      alpha: ["X", "A", "B", "C"],
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Four Digit",
      win_price: "2,50,000",
      price_name: "Buy price",
      digit_fee: 50.0,
      alpha: ["X", "A", "B", "C"],
      time: time,
    },
    {
      lottery: "kerala",
      digit_name: "Four Digit",
      win_price: "5,00,000",
      price_name: "Buy price",
      digit_fee: 100.0,
      alpha: ["X", "A", "B", "C"],
      time: time,
    },
  ]);

  const [singleData, setSingleData] = useState();
  const [doublePrice, setDoublePrice] = useState();
  const [bookingClosedTime, setBookingClosedTime] = useState();
  const current_slot = Array.isArray(slot)
    ? slot.find((item) => item?.id === slotId)
    : null;
  const bookingTimeData = current_slot?.booking_closed_at ?? bookingTime;
  const slotTimeData = current_slot?.lot_closed_at ?? slotTime;

  // Backend pushes live slot updates over the socket; if this slot's result
  // gets announced (status 4 or 5) while the user is on this screen, send
  // them back to Home immediately. Status 2/3 are just closed/pending states
  // and must NOT redirect here. winning_number is checked as a safety layer
  // since it stays null until the result is actually announced.
  useEffect(() => {
    if (
      [4, 5].includes(current_slot?.status) &&
      current_slot?.winning_number != null
    ) {
      naviagtion("/home", { replace: true });
    }
  }, [current_slot?.status, current_slot?.winning_number]);

  // Key for storing data in local store based on slotId
  const storeKey = slotId ? `slotData_${slotId}` : null;
  const storedSlotData = useStoreKv((state) =>
    storeKey ? state.kv[storeKey] : undefined,
  );

  const fetchData = async () => {
    try {
      const res = await get(`${URLS.SLOTLIST}/${slotId}`);
      const slotData =
        Array.isArray(res?.data) && res.data?.length > 0 ? res.data[0] : null;

      if (!slotData) {
        console.warn("No slot data found for slotId:", slotId);
        setSingleData([]);
        setDoublePrice([]);
        setThreeData([]);
        setBookingClosedTime(null);
        return;
      }

      const bookingClosedAt = slotData?.booking_closed_at || null;
      setBookingClosedTime(bookingClosedAt);

      const digitData = Array.isArray(slotData?.fee_prices)
        ? slotData.fee_prices
        : [];

      // Extracting data safely
      const singleDigit = digitData.filter((item) => item.type === 1) || null;
      const doubleDigit = digitData.filter((item) => item.type === 2) || null;

      setSingleData(singleDigit || []);
      setDoublePrice(doubleDigit || []);

      const threeDigit = digitData.filter((item) => item.type === 3) || [];
      const fourDigit = digitData.filter((item) => item.type === 4) || [];

      const updatedThreeDigit = threeDigit.map((item) => ({
        ...item,
        alpha: ["A", "B", "C"],
      }));

      const updatedFourDigit = fourDigit.map((item) => ({
        ...item,
        alpha: ["X", "A", "B", "C"],
      }));

      const threeAndFourDigit = [...updatedThreeDigit, ...updatedFourDigit];
      setThreeData(threeAndFourDigit);

      // Save fetched data to local store
      if (storeKey) {
        set(storeKey, {
          singleData: singleDigit || {},
          doublePrice: doubleDigit || {},
          threeData: threeAndFourDigit,
          bookingClosedTime: bookingClosedAt,
        });
      }
    } catch (error) {
      console.error("Error fetching slot data:", error);
      // fallback states in case of network error
      setSingleData([]);
      setDoublePrice([]);
      setThreeData([]);
      setBookingClosedTime(null);
    }
  };

  // Load data from local store initially
  useEffect(() => {
    if (storedSlotData) {
      setSingleData(storedSlotData.singleData || {});
      setDoublePrice(storedSlotData.doublePrice || {});
      setThreeData(storedSlotData.threeData || []);
      setBookingClosedTime(storedSlotData.bookingClosedTime || null);
    }
  }, [storedSlotData]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (bookingTimeData) {
      localStorage.setItem("bookingTime", bookingTimeData);
    }
  }, []);

  const handleGoCart = () => {
    // const cartString = localStorage.getItem("cart");
    // if (cartString?.length === 0) {
    //     Toast('Please play at least one game');
    //     return;
    // } else {
    naviagtion("/cart", { replace: true });
    // }
  };

  const handleFinish = useCallback(() => {
    setIsBookingClosed(true);
    // // console.log("Slot closed");
    naviagtion("/home", { replace: true });
  }, [naviagtion]);

  const closingTimeFinished = useCallback(() => {
    setIsLotClosed(true);
  }, []);

  return (
    <div className="lotteryContainer">
      {/* Header */}
      <div className="header">
        <h2 className="headerText">{`${lotName == "Kerala 3 PM" ? "KERALA " : "DEAR "}${time}`}</h2>
      </div>

      {/* Timers */}
      <div className="timeRow">
        {isLotClosed ? (
          <div className="timeBox">
            <p style={{ fontSize: 13, marginBottom: 2 }} className="timeSub">
              Lot
            </p>
            <h3 style={{ color: "#EA2E2E" }} className="timeLabel f3">
              Closed
            </h3>
          </div>
        ) : (
          <div className="timeBox">
            <h3 className="timeLabel f3">
              {moment(slotTimeData, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")}
            </h3>
            <p className="timeSub">Lot Closing</p>
            <p className="timeRemain">
              <Countdown
                isBookingTime={true}
                closingTime={slotTimeData}
                onFinish={closingTimeFinished}
              />
            </p>
          </div>
        )}
        <button className="priceBtn">
          <img src={priceDoc} style={{
            filter: "brightness(0) invert(1)"
          }} alt="price" className="priceIcon" />
          <span
            onClick={() => naviagtion("/price-list")}
            className="priceBtnText"
          >
            Price
          </span>
        </button>
        {isBookingClosed ? (
          <div className="timeBox">
            <p style={{ fontSize: 13, marginBottom: 2 }} className="timeSub">
              Booking
            </p>
            <h3 style={{ color: "#EA2E2E" }} className="timeLabel f3">
              Closed
            </h3>
          </div>
        ) : (
          <div className="timeBox">
            <h3 className="timeLabel f3">
              {moment(bookingTimeData, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")}
            </h3>
            <p className="timeSub">Booking Closing</p>
            <p className="timeRemain">
              {" "}
              <Countdown
                isBookingTime={true}
                closingTime={bookingTimeData}
                onFinish={handleFinish}
              />
            </p>
          </div>
        )}
      </div>

      {/* Digit Sections */}
      {singleData?.length > 0 && singleData.map((item, i) => (
        <SingleDigitScreen
          key={item.fee_price_id || i}
          userId={userId}
          bookingClosedTime={bookingClosedTime}
          slotId={slotId}
          lotTime={time}
          lotName={lotName}
          singleData={item}
        />
      ))}
      {doublePrice?.length > 0 && doublePrice.map((item, i) => (
        <DoubleDigitScreen
          key={item.fee_price_id || i}
          userId={userId}
          bookingClosedTime={bookingClosedTime}
          slotId={slotId}
          lotTime={time}
          lotName={lotName}
          doublePrice={item}  
          doubleData={doubleData}
        />
      ))}
      {threeData?.length > 0 && (
        <ThreeDigitScreen
          userId={userId}
          bookingClosedTime={bookingClosedTime}
          slotId={slotId}
          lotTime={time}
          lotName={lotName}
          threeData={threeData}
        />
      )}
      {/* Pay Now Button */}
      <button
        style={{ marginBottom: 40, color: 'white' }}
        className="confirmBtn"
        onClick={handleGoCart}
      >
        {loading ? "Loading..." : "Pay Now"}
      </button>
    </div>
  );
};

export default LotteryGameScreen;
